import React from "react";
import { useEffect, useState } from "react";
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useParams, useLocation, useNavigate } from "react-router-dom";

import CustomizedAccordions from "../../components/homepage/accordion";
import ContentCards from "../../components/homepage/contentCards";
import CustomContainer from "../../components/layout/container";
import CustomHeader from "../../components/layout/header";

import SenaryoLogo from "../../images/Senaryo_Logo_large.png";
import SenaryoRubikCube from "../../images/Senaryo_RubikCube.jpg"
import FeedbackFaces from "../../images/FeedbackFaces_Red.jpg"

const SenaryoCaseStudy = () => {
  // const router = useNavigate();
  // const { Senaryo } = useParams();

  const [pageTitle, setPageTitle] = useState("");
  const [borderColorToHighlight, setborderColorToHighlight] =
    useState("why/case-study/Senaryo");

  const breadcrumbData = [
    { name: "Home", link: "/" },
    {
      name: `Case Study (Senaryo)`,
      link: `/why/case-study/Senaryo`,
    },
  ];

  return (
    <Box>
      <Grid>
        <title>{pageTitle?.toUpperCase()} | MEF</title>
        <meta
          name="description"
          content="Identify & Quantify Macroeconomic/Esg risk"
        />
      </Grid>
      <CustomHeader
        title={"Client Case Study-Consultancy"}
        breadcrumbData={breadcrumbData}
      />

      <CustomContainer>
        <Box >
          <Grid container spacing={1.5}>
            <Grid item xs={12} sm={6} md={4}>
              <ContentCards
                imgSrc={SenaryoLogo}
                title="Client Profile - SME Consultancy"
                objectFit="contain"
                subTitle="Management Consultancy with Multinational Clients"
                //example to link in text
                body={`UK-based Senaryo are an international Consultancy who help clients/partners ideate, select and 
                  implement digital solutions supported by their experience and the 'digital playpen'  Cohesion™`}
              />
              <CustomizedAccordions
                title="Senaryo Service Offer"
                body={`The founders of Senaryo Services Ltd and many of their business partners have their roots in the information technology 
                industry and the transformational role that technology can play in creating company value... when managed well! The team have 
                been involved in scoping, analysing, designing, implementing delivering. monitoring and governing change programmes that have 
                added company level value to the organisations they have served as either employees or advisors. Recent projects that Senaryo have been involved in include:
              <ul>
                <li>Transforming Operating Models across multiple public and private sector organisations using OMDDMS.</li>
                <li>Expertise in Carbon Off-Setting and Net-Zero programmes.</li>
                <li>Demonstrating compliance in heavily regulated  sectors such as finance, government and telecommunications.</li>
                <li>Using compliance as a competitive edge in commercial markets., most notably Logistics and Supply Chain.</li>
                <li>Involvement is consultancy on Smart-Cities.</li>
              `}
              />
              <CustomizedAccordions
                title="Senaryo's Requirement from MEF"
                body={`Senaryo conduct regular analysis operational & regulatory risk for clients</b>. 
                But to cross-check thier domain-level risk analysis/methodology and to ensure the analysis is coherent, Senaryo see MEF as providing Global 
                Economic/Energy scenario projections projections using a <b>“top-down” approach</b>. This enables more robust, 360 degree, coherent sensitivity analysis to 
                be conducted on their clients' operational risk analysis.`}
              />

            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <ContentCards
                imgSrc={SenaryoRubikCube}
                title="Client Needs-Bespoke Model/Scenarios"
                objectFit="contain"
                subTitle={`Why Senaryo use MEF services - Global Risk Scenario Inputs`}
                body={`<p>Senaryo's risk mitigation consultancy focuses at the domain level of day-to-day operations & logistics and how
                    uncertainty & risk - operations shocks - can be anticipated & prepared for. But for Globally-active firms, such operational risks multiply
                    in an international arena. MEF provides risk scenario inputs testing sensitivities of the Global drivers of business operations on the coalface.
                    Such top-down risk analysis compliments well the domain level risk mitigation & preparedness that Senaryo specialise in.</p>`}
              />
              {/* <CustomizedAccordions
                title="Bespoke Scenarios"
                body={`<br><br>`}                     /> */}
              <CustomizedAccordions
                title="Senaryo Scenario Analysis & Playbooks; using Global Scenario Drivers "
                body={`Once playbooks are deployed, Senaryo need to “stress-test” official (ie OBR, OECD, IMF) Budget projections with plausible global macro scenarios to capture & quantify 
                domain-level uncertainty around central projections; these are then fed-through to Senaryo's unique <b>playbooks</b> to quantify related uncertainties at the client domain level.
                Senaryo would typically comission such Global scenario update exercises after each major fiscal event in the UK; they can then pre-empt any potential deviations from the 
                official baseline forecast and its ramifications for client playbooks that drive clients' risk mitigation planning at the coalface.`}
              />
              {/* Download not working ! + need .PDF icon
              <a href="./public/downloads/MEF_iDEA_CaseStudy.pdf">    <button>Case Study .PDF</button> </a>  */}
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <ContentCards
                imgSrc={FeedbackFaces}
                title="Client Feedback"
                objectFit="contain"
                subTitle={`On MEF services & how they underpin Senaryo's client offer`}
                body={`<i>"With the arrival of Donald Trump in the Whitehouse in 2017 we realised that to conduct our client-level advice & analysis on operational resilience 
                  we could no longer ignore the growing uncertainty/volatility unfolding 'out there' in the Global economy. Some of our clients are 
                  large, globally-trading, multinational operators who are on the front-line of Global economic/trade turbulence. So it was an obvious - and essential - 
                  upgrade decision to simply buy-in bespoke, Global scenario analysis on a regular basis to demonstrate due diligence on Economic/Energy risk to our consultancy 
                  clients.</i> <strong>Don Phillips, MD Senaryo Services Ltd</strong>"</i><br><br>
                <hr style="color:#00a0a0;height:1px;width:50%;">
                If you would like to initiate an informal chat about how MEF's modelling and/or scenario services may augment your risk analysis, please email us
                at: <b style="color:#00a0a0" > bespoke@mef-uk.com </b> `}
              />
            </Grid>
          </Grid>
        </Box>
      </CustomContainer>
    </Box>
  );
};

export default SenaryoCaseStudy;
// IDEACaseStudy.getInitialProps = async ({ whyData }: any) => {
//   return whyData;
// };
